<template>
  <div class="document-guidance">
    <h1>文书指导</h1>
    <div class="service-category">留学服务</div>

    <section class="guidance-section">
      <div class="intro">
        <p>
          在申请加拿大大学时，准备一份优秀的申请文书至关重要的，加拿大大学学部会在审理申请人的综合面貌时，以此来展示个人的全能力和积极性之处。
        </p>
        <p>
          文书主要包括个人综合能力表，学术能力和研究经历、领导能力和团组参与、表达能力和写作技巧、个人特长和兴趣爱好等八个方面。最基本和重要的文书要包括以下几个部分：CV/Resume(简历)、Reference Letter(推荐信)、Essay论文及Personal Statement个人陈述。
        </p>
      </div>

      <div class="document-types">
        <h2>CV/Resume个人简历</h2>
        <p>
          个人简历也被称为个人经历知识的汇报整理总结。在填写大文书中，个人经历知识要是一个非常重要的创新点。加拿大大学非常注重申请人的全方位的呈现。因此，在个人简历中，需要展示出自己独特的特征和经历，如课外团体的文化交流活动、实践者活动、社会实践经验等。同时，在简历编辑过程中还需要展示自己在社会经历中所得到的收获，以及如何对自己未来的大学学习生活有所帮助。
        </p>
        <p>
          本科生的CV一般包括内容有：个人基本信息、教育背景、语言和学术经历、学习活动、自愿者活动、领导经历、实习工作、荣誉证书及及个人评价等。研究生CV一般包括内容有：个人基本信息、教育背景、语言和学术经历、学术组织及活动、实习活动、出版物和研究成果等。
        </p>

        <h2>Reference Letter推荐信</h2>
        <p>
          推荐信由申请人的两三名老师，对申请人特长，学习以及实践过程中的表现，来科任一般要求2位推荐信。研究生一般要求3位推荐信。如以由工作经验，可以由学校的代课老师。院长或主任等写推荐信。
        </p>
        <p>
          如果选择的是学术性的老师，也以选择老师，项目导师作为推荐者，第二推荐信可以由实习单位的主管写。如果选择的是学术性的老师，比如过往老师，工作能力的特长，推荐者写推荐信时要突出申请者的学术能力和研究能力。团队合作能力，解决问题的能力和团队协作能力和创造能力。
        </p>

        <h2>Essay论文</h2>
        <p>
          在申请过程中，学校会出加3个小问题(最体会小学分数学校除外)，一般是关于个人身份的认识题目，或者是关于对某种现象的思考，或是对自己的经历的思考。需要你用自己的语言，结合自己的能力和素养，以及自己的经历来阐述你对这些问题的看法。同时，在文章中要体现出自己的思维逻辑和表达能力，以及如何将自己的经历和思考融入到文章中去。
        </p>

        <h2>Personal Statement个人陈述</h2>
        <p>
          个人陈述主要是阐述申请人教育背景、目前取得的成就以及未来目标方向。在个人陈述中，需要详细说明自己在学术方面的成就和发展，以及中对自己研究方向的认识和分析，并且展示自己有能力完成大大学的研究项目和课业要求。加拿大大学希望看到学生的学术能力和研究兴趣，以及对自己未来发展方向的规划。
        </p>
        <p>
          另外，在个人陈述中还要展示自己在社会实践中的经历和收获。可以通过举例来说明自己在学术、社会实践中的贡献和成长。同时，加拿大大学希望看到申请人个人特长和兴趣爱好。在文章中要突出自己的个性化和创造力，并且要让面试官看到自己的潜力和发展前景。
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DocumentGuidanceView'
}
</script>

<style scoped lang="less">
.document-guidance {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .service-category {
    color: #666;
    font-size: 18px;
    margin-bottom: 30px;
  }

  .guidance-section {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .intro {
      margin-bottom: 40px;

      p {
        margin-bottom: 20px;
        line-height: 1.8;
        color: #444;
      }
    }

    .document-types {
      h2 {
        font-size: 24px;
        color: #333;
        margin: 30px 0 15px;
        padding-bottom: 10px;
        border-bottom: 2px solid #eee;
      }

      p {
        margin-bottom: 15px;
        line-height: 1.8;
        color: #555;
        text-align: justify;
      }
    }
  }
}
</style>